import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import defaultAvatar from '../../../assets/images/defaultAvatar.png';
import { Header } from '../../../common/components';
import { WIDGET_STATE } from '../../../common';
import { WidgetContext } from '../../App';
import * as styles from './ChatHeader.module.css';
export const ChatHeader = () => {
    var _a, _b, _c, _d;
    const intl = useIntl();
    const { widgetSettings, socketService } = useContext(WidgetContext);
    const [operatorName, setOperatorName] = useState((_b = (_a = socketService === null || socketService === void 0 ? void 0 : socketService.joinResponseData) === null || _a === void 0 ? void 0 : _a.executor) === null || _b === void 0 ? void 0 : _b.name);
    useEffect(() => {
        if (!socketService)
            return;
        const eventListener = {
            'join response': (data) => {
                var _a;
                data && setOperatorName((_a = data.executor) === null || _a === void 0 ? void 0 : _a.name);
            },
        };
        socketService.addEventListener(eventListener);
        return () => socketService.removeEventListener(eventListener);
    }, [socketService]);
    const redirectState = (widgetSettings === null || widgetSettings === void 0 ? void 0 : widgetSettings.blocks.includes('knowledge')) && WIDGET_STATE.KNOWLEDGE_BASE;
    const avatar = ((_d = (_c = socketService === null || socketService === void 0 ? void 0 : socketService.joinResponseData) === null || _c === void 0 ? void 0 : _c.executor) === null || _d === void 0 ? void 0 : _d.image_url) || defaultAvatar;
    return (_jsx(Header, { redirectState: redirectState, redirectText: intl.formatMessage({ id: 'back' }), className: styles.chatHeaderContainer, classNameRedirect: styles.chatHeaderRedirect, children: _jsxs("div", { className: styles.avatarContainer, children: [_jsx("img", { src: avatar, alt: 'avatar', className: styles.avatar, draggable: 'false' }), _jsxs("div", { children: [_jsx("div", { className: styles.name, children: operatorName || intl.formatMessage({ id: 'operator' }) }), _jsxs("div", { className: styles.onlineStatusContainer, children: [_jsx("div", { className: styles.onlineCircle }), _jsx("div", { className: styles.onlineText, children: intl.formatMessage({ id: 'onlineStatus' }) })] })] })] }) }));
};
